import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ToasterService } from '@purespectrum1/ui/toaster-service';
import { FormatQuotaInterface } from '../../../shared/interfaces/manage-quotas.interface';
import { Quotas, Survey } from '../../../shared/interfaces/survey.interface';
import { BuyerApiService } from '../../../shared/services/buyer-api/survey.service';
import { PurePriceService } from '../../../shared/services/pure-price/pure-price.service';

@Component({
  selector: 'ps-ui-price-view-block',
  templateUrl: './price-view-block.component.html',
  styleUrls: ['./price-view-block.component.css'],
})
export class PriceViewBlockComponent implements OnInit {
  @Input() surveyData!: Survey;
  @Input() quotas!: FormatQuotaInterface;
  @Output() purePriceQuotaChanged = new EventEmitter<string>();
  constructor(
    private _toastr: ToasterService,
    private _buyerApiService: BuyerApiService,
    private _purePriceService: PurePriceService
  ) {}

  quotasToShow: FormatQuotaInterface = {};

  ngOnInit(): void {
    //Filtering just quotas which has QBP values for Reco
    Object.keys(this.quotas).forEach((chave) => {
      if (this.quotas[chave].filter((valor) => valor.qbp).length > 0) {
        this.quotasToShow[chave] = this.quotas[chave];
      }
    });
  }

  applyRecommendedCpi = (item: Quotas) => {
    const quotaId = item.ps_quota_id;
    const recommendedCpi = item.priceRecommendCpi;
    const updatedPayload = [
      {
        op: 'replace',
        path: '/cpi',
        value: recommendedCpi,
      },
    ];
    this._buyerApiService
      .updateQuotaData(this.surveyData.id, quotaId, updatedPayload)
      .subscribe(
        (response) => {
          this._toastr.success('Success! CPI has been updated');
          if (item && item.qbp) {
            item.qbp.cpi = recommendedCpi;
            item.diffCpi = 0;
          }
        },
        (error) => {
          this._toastr.error(error.error.ps_api_response_message);
        }
      );
    this._purePriceService.pushApplyPriceRecoButtonCount(this.surveyData.id);
    this.purePriceQuotaChanged.emit();
  };
}
